import env from './env';

/**
 * Using the application key creates the key for storage.
 *
 * @param {string} key Key for storage
 */

const name = key => `${env('APP_KEY')}_${key.toUpperCase()}`;

/**
 * Clear all local storage.
 */

const clear = () => (
  localStorage.clear()
);

/**
 * Retrieve a value by the key.
 *
 * @param {string} key Key for storage
 */

const get = key => (
  JSON.parse(localStorage.getItem(name(key)))
);

/**
 * Remove an item by key from local storage.
 *
 * @param {string} key Key for storage
 */

const remove = key => (
  localStorage.removeItem(name(key))
);

/**
 * Add key and value to local storage.
 *
 * @param {string} key Key for storage
 * @param {*} value Value for storage
 */

const set = (key, value) => (
  localStorage.setItem(name(key), JSON.stringify(value))
);

export default {
  clear,
  get,
  remove,
  set,
};
